
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'
import ModalStylePageLayout from '@/components/organisms/layout/ModalStylePageLayout.vue'
import QuestionResultTip from '@/components/organisms/QuestionResultTip.vue'
import { LearningProblemCurriculumUnit } from '@/models/LearningProblemCurriculumUnit'
import DateUtils from '@/utils/DateUtils'

/**
 * 演習履歴一覧
 */
@Component({
  components: {
    ButtonSubmit,
    ModalStylePageLayout,
    QuestionResultTip,
  },
})
export default class ProblemHistoryList extends Vue {
  /** 単元名 */
  @Prop()
  private curriculumUnitName!: string

  /** 問題レベル */
  @Prop()
  private problemLevel!: string

  /** 演習履歴一覧 */
  @Prop()
  private problemHistoryList!: LearningProblemCurriculumUnit.ProblemHistory[]

  /** 履歴クリック時のイベント */
  @Prop()
  private eventClickHistory!: (learningId: number) => void

  /** 戻るボタン押下時のイベント */
  @Prop()
  private eventClickBackButton!: () => void

  /**
   * 日付フォーマット
   *
   * @param date 日付
   * @returns フォーマットされた日付
   */
  private dateFormat(date: Date): string {
    return DateUtils.format(date)
  }
}
